(( $, wp ) => {

    const { __, _x, _n, _nx } = wp.i18n;
    const { Fragment } = wp.element;
    const { SelectControl, TextControl, PanelBody, PanelRow } = wp.components;
    if (typeof wp.blockEditor != "undefined") var { InspectorControls } = wp.blockEditor;
    else var { InspectorControls } = wp.editor;


    wp.blocks.registerBlockType( 'discord-wordpress-plugin/dwpp-connect-profile-gutenberg-block', {

        // Block setup
        title: __('Connect Discord Profile Button', 'discord-wordpress-plugin'),
        description: <p>
                        { __('Block outputs an HTML link to connect the WP profile with the Discord profile.', 'discord-wordpress-plugin') }
                        <br/><br/>
                        <i>{ __('If WP user is not authorized shortcode will return nothing.', 'discord-wordpress-plugin') }</i>
                    </p>,
        icon: <svg width="430" height="430" viewBox="0 0 430 430">
                <path fill="#daa772" d="M339.764 87.7497C344.539 92.5278 346.927 98.3391 346.927 105.183C346.927 112.028 344.539 117.904 339.764 122.811L262.131 200.294L291.171 229.35L260.195 260.343C239.157 281.393 214.022 293.435 184.789 296.47C155.556 299.505 129 293.016 105.123 277.002L35.0412 347.125H0V312.064L70.0823 241.941C54.0782 218.051 47.5927 191.48 50.6258 162.23C53.6588 132.98 65.6941 107.831 86.7317 86.7812L117.707 55.7879L146.747 84.8441L224.186 7.16719C229.09 2.38906 234.963 0 241.803 0C248.644 0 254.452 2.38906 259.227 7.16719C264.003 11.9453 266.39 17.7888 266.39 24.6978C266.39 31.6067 264.003 37.4502 259.227 42.2283L181.788 119.905L227.09 165.233L304.723 87.7497C309.627 82.9716 315.499 80.5825 322.34 80.5825C329.18 80.5825 334.988 82.9716 339.764 87.7497Z"/>
                <rect x="238" y="238" width="177" height="145" fill="white"/>
                <path fill="#7289DA" d="M355.17,317.14a10.72,10.72,0,0,1-10.69,10.71,11.06,11.06,0,0,1-7.62-3.18,10.3,10.3,0,0,1-3.07-7.45,10.72,10.72,0,0,1,10.69-10.71v0A10.66,10.66,0,0,1,355.17,317.14Zm-47.47-10.67,0,0A10.72,10.72,0,0,0,297,317.21a10.3,10.3,0,0,0,3.07,7.45,11.06,11.06,0,0,0,7.62,3.18,10.69,10.69,0,0,0,0-21.38ZM430,237.17V430l-25.28-20.36-13.83-12-15.15-12.52L382,404.88H249.65c-13.21,0-24-9.57-24-22.17V237.22c0-12,10.74-22.17,24-22.17l155.72,0C418.66,215,429.34,225.18,430,237.17ZM347.27,266l.32-.09h-.23Zm49.49,74.23c0-34.65-17.13-62.87-17.13-62.87-15.32-10.8-29.62-11.28-32.32-11.28l-1.74,1.63c19.56,5.38,29,13.76,29,13.76a109.65,109.65,0,0,0-87.07-3.61c-4.43,1.81-6.95,3-6.95,3s9.42-9,30.26-13.76l-1.28-1.19s-15.82-.57-32.82,11.37c0,0-17.05,28.13-16.89,63,0,0,9.42,15.61,35.29,16.18,0,0,3.75-4.81,7.59-9-14.54-4.19-20.2-12.57-20.2-12.57l4.85,2.38c14.21,5.55,29.25,12.56,56,8.37,5.62-1.23,11.29-2.42,17-4.8,3.67-1.81,8.19-3.61,13.17-6.61,0,0-5.65,8.38-20.79,12.57,3.11,4.19,7.5,9,7.5,9C386.16,355.19,396.22,339.61,396.77,340.24Z"/>
            </svg>,
        category: 'discord-wordpress-plugin-blocks',


        // Custom attributes
        attributes: {
            connectText: {
                type: 'string',
                default: __('Connect Discord Profile', 'discord-wordpress-plugin'),
            },
            disconnectText: {
                type: 'string',
                default: __('Disconnect Discord Profile', 'discord-wordpress-plugin'),
            },
            styling: {
                type: 'string',
                default: 'no',
            },
        },


        // Main editor function
        edit: props => {

            return [

                // Sidebar controls
                <Fragment>
                    <InspectorControls>
                        <PanelBody title={'View'} initialOpen={true}>
                            <PanelRow>
                                <TextControl
                                    label={ __('Connect text', 'discord-wordpress-plugin') }
                                    value={ props.attributes.connectText }
                                    onChange={ value => props.setAttributes({ connectText: value }) }/>
                            </PanelRow>
                            <PanelRow>
                                <TextControl
                                    label={ __('Disconnect text', 'discord-wordpress-plugin') }
                                    value={ props.attributes.disconnectText }
                                    onChange={ value => props.setAttributes({ disconnectText: value }) }/>
                            </PanelRow>
                            <PanelRow>
                                <SelectControl
                                    label={ __('Style', 'discord-wordpress-plugin') }
                                    onChange={ value => props.setAttributes({ styling: value }) }
                                    options={[
                                        { value: 'no', label: __('None', 'discord-wordpress-plugin') },
                                        { value: 'default', label: __('Default', 'discord-wordpress-plugin') }
                                    ]}
                                    value={ props.attributes.styling }/>
                            </PanelRow>
                        </PanelBody>
                    </InspectorControls>
                </Fragment>,

                // Output in editor
                <a className={"dwpp__connect-profile dwpp__button--" + props.attributes.styling + "-style"} href="javascript:void(0)">
                    { props.attributes.disconnectText }
                </a>
            ];
        },


        // Front end save
        save: () => {
            return null;
        },

    });
})( jQuery, wp );
